import type {Comparator} from 'nutshell-graphql-types';

export const FIELDS = [
    'accountType',
    'emailDomain',
    'industry',
    'market',
    'products',
    'sources',
    'tags',
    'territory',
    'value',
] as const;

export type LeadDistributionRule = {
    criteriaField: string | null | undefined;
    criteriaValues: string[];
    valueComparator: Comparator;
};
